const { default: AnimatedComponent } = require("./animatedComponent");

class Popup extends AnimatedComponent {

    /**
     * 
     * @param {*} options 
     */
    constructor(options = {}) {

        let state_list = {
            visibility: ['open', 'closed'],
        }
        let state_active_list = {
            visibility: 'closed',
        }

        let options_default = {
            classNames: [],
            className: 'popup',
            dataElement: 'popup',
            move: true,
            clone: false,
            movementType: 'move', // move|clone
            class_prefix: 'popup--',
        }
        options = {...options_default, ...options}

        let element = document.querySelector(`[data-element="popup"]`);

        let is_created = !!( element )

        if ( !is_created ) {
            let popup = document.createElement('div');
            popup.classList.add(options.className);
            popup.dataset.element = options.dataElement;
            popup.innerHTML = `
                <div class="${options.className}__layout"></div>
                <div class="${options.className}__window">
                    <button type="button" class="${options.className}__btn-close btn-close">
                        <img class="btn-close__icon" src="./assets/images/dropdown-marker.svg" alt="dropdown-marker" />
                    </button>
                    <div class="${options.className}__message-block">
                        <p class="${options.className}__title"></p>
                        <p class="${options.className}__message"></p>
                    </div>
                    <div class="${options.className}__scroll">
                        <div class="${options.className}__position">
                            <div class="${options.className}__content">
                            </div>
                        </div>
                    </div>
                </div>
            `
            document.body.append(popup)

            element = popup;
        }

        let elements = {
            component: element,
            layout: element.querySelector(`.${options.className}__layout`),
            scroll: element.querySelector(`.${options.className}__scroll`),
            window: element.querySelector(`.${options.className}__window`),
            btn_close: element.querySelector(`.${options.className}__btn-close`),
            message_block: element.querySelector(`.${options.className}__message-block`),
            title: element.querySelector(`.${options.className}__title`),
            message: element.querySelector(`.${options.className}__message`),
            content: element.querySelector(`.${options.className}__content`),
        }

        super(element, state_list, state_active_list, null, options)

        if ( !is_created ) {
            if ( typeof SimpleBar !== 'undefined' ) {
                new SimpleBar(elements.scroll)
            }
            elements.btn_close.addEventListener('click', e => this.close());
            elements.layout.addEventListener('click', e => this.close());
            document.addEventListener('keydown', (e)=>{
                if (e.key === "Escape") {
                    this.close()
                }
            })
        }
        
        this.options = options
        this.elements = elements
        this.scrollbar = window.scrollbar || null
        this.putbackElement = null
    }

    _appendClone(element) {
        let clone = element.cloneNode(true)
        clone.removeAttribute('id')
        this.elements.content.innerHTML = ''
        this.elements.content.append(clone)
    }

    _setOptions(options) {
        
        this.options = {...this.options, ...options}

        if (options.className) {
            this.options.classNames.push(this.options.className)

            // очищаем заданные ранее классы
            let currentClassNames = Array.from(this.popup.classList)
            let defaultClassNames = [...this.options_default.classNames, this.options_default.className]
            currentClassNames.forEach(className => {
                if (!defaultClassNames.includes(className)) {
                    this.popup.classList.remove(className)
                }
            });
    
            if (this.options.classNames.length) {
                this.popup.classList.add(...this.options.classNames)
            }
        }

        if (this.options.className) this.options.classNames.push(this.options.className)
    }

    _setContent(content) {
        this.content = {...this.content, ...content}

        for (const [key, value] of Object.entries(this.content)) {

            switch (key) {
                case 'title':
                case 'message':
                    if ( this.elements[key] === undefined ) {
                        continue
                    }
                    this.elements[key].innerHTML = value
                    if (!value) {
                        this.elements[key].style.display = 'none'

                    } else {
                        this.elements[key].style.display = ''
                    }
                break;

                case 'element':
                    if (this.options.movementType === 'move') {
                        if (this.elements.content.contains(content.element)) {
                            // nothin
                        } else {
                            if (this.putbackElement) {
                                for (const child of this.elements.content.children) {
                                    this.putbackElement.append(child)
                                }
                            }
        
                            this.putbackElement = content.element.parentElement
                            this.elements.content.innerHTML = ''
                            this.elements.content.append(content.element)
                        }
        
                    } else if (this.options.movementType === 'clone') {
                        this.elements.content.innerHTML = ''
                        this._appendClone(content.element)
                    }
                break;

                default:
                break;
            }
        }
    }

    open() {
        this.scrollbar && this.scrollbar.off()
        return this.changeState('visibility', 'open', this.element)
            .then((status)=>{
                if (!status) this.scrollbar && this.scrollbar.on()
            })
    }

    close() {
        return this.changeState('visibility', 'closed', this.element)
        .then((status)=>{
            this.scrollbar &&  this.scrollbar.on()
        })
    }

    /**
     * 
     * @param {string} content.title 
     * @param {string} content.message
     * @param {HTMLElement} content.element
     * @param {*} options 
     * @returns 
     */
    set( content = {}, options = {} ) {
        this._setOptions(options)
        this._setContent(content)

        return this
    }
}

export default Popup